import { CopyOutlined, DeleteOutlined } from "@ant-design/icons"
import { Button, Flex, Space, Tooltip, Typography } from "antd"
import React from "react"

interface ProjectTypeMilestoneHeaderProps {
  saving: boolean
  copyAllowed?: boolean
  deleteAllowed?: boolean
  onCopyPhase: () => void
  onDeletePhase: () => void
}

export function ProjectTypeMilestoneHeader({
  saving,
  copyAllowed,
  deleteAllowed,
  onCopyPhase,
  onDeletePhase
}: ProjectTypeMilestoneHeaderProps) {
  return (
    <Flex justify={"space-between"} align={"center"} className={"px-2 pt-2"}>
      <Typography.Title level={3}>Milestone Details</Typography.Title>
      <Space>
        {copyAllowed && (
          <Tooltip title={"Copy milestone"}>
            <span>
              <Button
                disabled={saving}
                onClick={onCopyPhase}
                icon={<CopyOutlined />}
              />
            </span>
          </Tooltip>
        )}
        {deleteAllowed && (
          <Tooltip title={"Delete milestone"}>
            <Button onClick={onDeletePhase} danger icon={<DeleteOutlined />} />
          </Tooltip>
        )}
      </Space>
    </Flex>
  )
}
